// Angular dependencies
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { AuthService, ApiService } from '../core/upgraded-providers';

export interface IUserRoomsResponse {
    shards: {
        [key: string]: string[];
    };

    reservations?: {
        [key: string]: string[];
    };
}

@Injectable()
export class UserRoomsService {
    _roomsSbj: BehaviorSubject<IUserRooms> = new BehaviorSubject(null);
    public rooms$: Observable<IUserRooms> = this._roomsSbj.asObservable();

    constructor(
        private _apiService: ApiService,
        private _authService: AuthService
    ) {
        this.getRooms();
    }

    async getRooms() {
        const { _id } = this._authService.Me;
        let { shards, reservations }: IUserRoomsResponse = await this._apiService.get('user/rooms?reservation', { id: _id });

        shards = shards ? shards : {};
        reservations = reservations ? reservations : {};

        const shardNames = new Set([...Object.keys(shards), ...Object.keys(reservations)]);

        const promises = [...shardNames].map((shard) => {
            const rooms = [];

            if (shards[shard]) {
                rooms.push(...shards[shard]);
            }

            if (reservations[shard]) {
                rooms.push(...reservations[shard]);
            }

            if (!rooms.length) {
                return new Promise((resolve) => resolve({ shard, rooms: [] }));
            }

            return this._apiService.post(`game/rooms?shard=${ shard }`, { rooms })
                .then(({ rooms }) => ({
                    shard, rooms: rooms.map((room) => {
                        let reservation = false;

                        if (reservations[shard]) {
                            reservation = reservations[shard].includes(room.room);
                        }

                        return {
                            ...room,
                            reservation
                        };
                    })
                }));
        });

        const shardsArr = await Promise.all(promises);

        const rooms: IUserRooms = shardsArr.reduce((shards: any, { shard, rooms }) => ({
            ...shards,
            [shard]: rooms
        }), {}) as IUserRooms;

        this._roomsSbj.next(rooms);
    }
}
